import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid/types";
import { AssetTableRowData } from "../types";
import { AssetColumns } from "~/modules/assets/types";
import { Link } from "~/components/Link";
import { getManagerURL } from "~/routes";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";
import { Emdash } from "~/components/Punctuation";

// // // //

export const MANAGER_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    label: "Asset Manager",
    slug: AssetColumns.managerID,
    tooltip: CatalogReferenceDataSlugs.manager,
    sortsOn: "manager.name" as AssetColumns,
    type: ColumnTypes.string,
    width: 180,
    loginRequired: true,
    render: (item) => {
        if (item.isAsset) {
            if (!item.manager) {
                return <Emdash />;
            }

            return (
                <Link
                    href={getManagerURL({ managerSlug: item.manager.slug })}
                    variant="default"
                    className="w-full flex items-center gap-2"
                    analyticsLabel={AssetUserEvents.ClickManagerIndividualLink}
                    analyticsEventProperties={{
                        manager: item.manager.slug,
                    }}
                >
                    <ImageLoader
                        src={item.manager.icon_url || RWA_COIN_ICON}
                        alt={`${item.manager.name} Icon`}
                        fallbackSrc={RWA_COIN_ICON}
                        className="h-5 w-5 min-w-5 rounded-full"
                        fallbackClassName="bg-white opacity-50"
                    />
                    <span className="dg-overflow">{item.manager.name}</span>
                </Link>
            );
        }

        return <Emdash />;
    },
};
